<template>
    <div class="invoice_images">
        <div class="flex">
            <draggable v-model="images" class="drag-container" @end="onDragEnd">
                <div v-for="(item, indexs) of images" class="u_poa">
                <img :src="item" alt="" class="invoice_images_item" @click="previewImg(item)" />
                <i class="el-icon-error icon_error" @click="closeImg(indexs)" ></i>
            </div>
    </draggable>
        </div>
        <el-upload
            class="v_upload"
            ref="upload"
            action="#"
            :drag="true"
            :show-file-list="false"
            :http-request="upload"
            :limit="limit"
            :multiple="multiple"
            :on-exceed="handleExceed"
            v-if="images.length < limit || images.length == 0"
        >
           +
        </el-upload>
    </div>
</template>
<script>
import axios from 'axios';
import draggable from 'vuedraggable';
export default {
    components: {
    draggable,
  },
    props: {
        limit: {
            type: Number,
            default: ''
        },
        multiple: {
            type: Boolean,
            default: false
        },
        images: {
            type: Array,
            default:()=>[]
        },
        
    },
    data:{
        config:{},
    },
    mounted() {
        this.getConfig()
    },
    methods: {
        getConfig() {
            var that = this;
            that.$get('/clientapi/oss2_info').then(function (res) {
                that.config = res.data;
            });
        },
        previewImg(url) {
            this.$hevueImgPreview(url);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`最多只能上传${this.limit}张图片！`);
        },
        // 上传图片
        upload(res) {
            let that = this;
            if (that.images.length == that.limit) {
                that.$message({
                    type: 'warning',
                    message: `图片最多上传${this.limit}张`
                });
                return;
            }
            let file = res.file;
         
            
            if (file.size >= 1048576 * 5) {
                that.$message({
                    type: 'warning',
                    message: '图片最大不能超过5M'
                });
                return;
            }
            const val = file.name;
            let suffix = val.substring(val.lastIndexOf('.') + 1, val.length); // -拿到后缀，又把后缀拼回去
            if (!['png', 'jpg', 'jpeg'].includes(suffix)) {
                this.$message({
                    type: 'error',
                    message: '文件格式错误'
                });
                return;
            }
            let filename = file.uid + '.' + suffix;
            var formData = new FormData();
            formData.append('key', that.config.dir + filename); //存储在oss的文件路径
            formData.append('OSSAccessKeyId', that.config.accessid); //accessKeyId
            formData.append('policy', that.config.policy); //policy
            formData.append('Signature', that.config.signature); //签名
            //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
            formData.append('file', file);
            formData.append('success_action_status', 200); //成功后返回的操作码
            var url = that.config.host;
            var fileUrl = that.config.host + '/' + that.config.dir + filename;
            axios.post(url, formData).then((res) => {
                // console.log('res :>> ', res);
                if(res.status==200){

                if (that.images.length == that.limit) {
                    that.$message({
                        type: 'warning',
                        message: `图片最多上传${this.limit}张`
                    });
                    return;
                }
                
                that.images.push(fileUrl);
              
                that.$emit('getImages', that.images); 
                that.$refs.upload.clearFiles();
            }

            });
        },
        onDragEnd(){
                this.$emit('getImages', this.images); 

        },
        closeImg(index) {
            this.images.splice(index, 1);
            this.$emit('getImages', this.images);
        }
    },
    data() {
        return {};
    }
};
</script>
<style lang="scss" scoped>
/deep/.v_upload .el-upload  {
    width: 78px;
    height: 78px;
    margin-right: 5px;

    border: none !important;
    background: #fff !important;
}
/deep/.v_upload .el-upload-dragger {
    width: 78px;
    height: 78px;
    border: none !important;
    background: #fff !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #363636;

}
.drag-container{
    display: flex;
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
// 上传图片
.image {
    width: 100%;
    border: 1px solid #212121;
    background: #363636;
    padding: 37px 0 26px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    .u_upload {
        width: 100%;
        height: 100%;
    }
}
.invoice_images{
    display: flex;
    flex-wrap: wrap;
}
.u_poa {
    position: relative;
    margin-right: 2px;
    .invoice_images_item {
        width: 78px;
        height: 78px;
        margin-right: 5px;
    }
    .icon_error {
        position: absolute;
        right: -5px;
        top: -5px;
        font-size: 15px;
        color: red;
        display: none;
        z-index: 2;
    }
}
.u_poa:hover .icon_error {
    display: block !important;
}
/deep/.el-upload-dragger {
    width: 111px;
    height: 94px;

    border: none !important;
    background: #363636 !important;
}
/deep/.el-upload {
    width: 111px;
    height: 94px;

    border: none !important;
    background: #363636 !important;
}

</style>
